export function getNumArray(startNum: number, step: number, length: number): number[] {
	return Array.from(Array(length), (_, index) => index * step + startNum);
}
